/**
 * API 配置管理
 * 控制哪些 API 使用 MSW，哪些使用真實後端
 */

import { apiConfigLoader } from './ApiConfigLoader'
import { logger } from '@/utils/logger'

export interface ApiModuleConfig {
  enabled: boolean
  baseUrl?: string
  description: string
}

export interface ApiConfig {
  useMsw: boolean
  realApiBaseUrl: string
  modules: Record<string, ApiModuleConfig>
}

export const API_CONFIG: ApiConfig = {
  // 全域控制：是否啟用 MSW
  useMsw: import.meta.env.VITE_USE_MSW !== 'false',
  
  // 真實 API 基礎 URL
  realApiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080',
  
  // 模組級別控制（向後相容）
  modules: {
    auth: {
      enabled: true,
      description: '身份驗證相關 API'
    },
    staff: {
      enabled: true,
      description: '員工搜尋與管理 API'
    },
    products: {
      enabled: true,
      description: '商品相關 API'
    },
    channels: {
      enabled: true,
      description: '主辦單位相關 API'
    },
    vendors: {
      enabled: true,
      description: '店家相關 API'
    }
  }
}

/**
 * 取得完整的 API URL
 */
export function getApiUrl(endpoint: string): string {
  // 全域開關：如果完全關閉 MSW，所有 API 都走真實後端
  if (API_CONFIG.useMsw === false) {
    return `${API_CONFIG.realApiBaseUrl}${endpoint}`
  }
  
  // 啟用 MSW 模式：透過配置判斷此端點是否使用 MSW
  const shouldUseMsw = apiConfigLoader.shouldUseMsw(endpoint)
  if (shouldUseMsw) {
    return endpoint // MSW 攔截
  } else {
    return `${API_CONFIG.realApiBaseUrl}${endpoint}` // 真實 API
  }
}

/**
 * 初始化 API 配置
 * 在應用啟動時調用以載入配置
 */
export async function initializeApiConfig(): Promise<void> {
  if (API_CONFIG.useMsw !== false) {
    try {
      await apiConfigLoader.loadConfig()
      logger.info('🔧 API 配置已載入')
    } catch (error) {
      logger.error('載入 API 配置失敗，使用預設配置', error)
    }
  }
}